import { 
	UploadError, 
	UploadException 
} from 'phoenix/domain';

export class UploadExceptionFactory{
    public static $inject = [
        'gettextCatalog'
    ];

    constructor(public gettextCatalog){}

    public create(errorCode:UploadError, fileName:string){
        return new UploadException(
            this.gettextCatalog,
            errorCode,
            fileName
        );
    }
}


// WEBPACK FOOTER //
// ./src/phoenix/factories/upload-exception-factory.ts